import React from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "./ScreenTabs.css";

const ScreenTabs = ({ items = [] }) => {
  const location = useLocation();
  const normalizedPath = (() => {
    const p = (location.pathname || "/").replace(/\/+$/, "") || "/";
    if (p === "/") return "/SquadDataScreen";
    return p;
  })();

  return (
    <div className="screen-tabs-wrap">
      <Nav activeKey={normalizedPath} className="screen-tabs mb-3">
      {items.map((item) => (
        <Nav.Item key={item.to}>
          <Nav.Link as={Link} to={item.to} eventKey={item.to} className="screen-tab-link">
            {item.label}
          </Nav.Link>
        </Nav.Item>
      ))}
      </Nav>
    </div>
  );
};

export default ScreenTabs;
